import React from "react";

import Link from "components/NavLink";
import PropertyDocuments from "components/PropertyDocuments";
import MultipleExpandableTabs from "components/MultipleExpandableTabs";
import ExpandableTab from "components/ExpandableTab";
import DOMPurify from "isomorphic-dompurify";

const section = (component, subSections) => {
    const tData = [];
    if (subSections) {
        for (let i = 0, len = subSections.length; i < len; i++) {
            const sec = subSections[i];
            tData[i] = {
                id: sec.sectionTitle,
                title: sec.sectionTitle,
                children: () => (
                    <div
                        className="expanded-content"
                        dangerouslySetInnerHTML={{ __html: DOMPurify?.sanitize?.(sec.sectionContent) }}
                    />
                ),
            };
        }
    }

    return (
        <>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify?.sanitize?.(component) }} />
            {subSections && (
                <div className={"flex column expanded-container sub-sections"}>
                    <div className="flex column">
                        <div className="flex column expanded-items">
                            <MultipleExpandableTabs closeAll={false} tabsData={tData} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const sectionPrivateTab = (name) => (
    <Link href={"/login?register=true"} as={{ pathname: "/login" }} className="private-tab">
        <div className={"flex column info-item"} role="button">
            <div className="flex row justify-between headline toggle private-headline">
                <div>
                    <h5 className="name my-0 actual fw-500">{name}</h5>
                    <h5 className="name my-0 hidden-text fw-500">Jetzt registrieren, um alle Inhalte freizuschalten</h5>
                </div>
                <div className="flex row align-center arrow-container">
                    <i className="fas fa-lock" />
                </div>
            </div>
        </div>
    </Link>
);

const ExpandedTabsBlock = ({ sections, documents, news, isLoggedIn, title = "Alle Infos zum Investment" }) => {
    const tData = [],
        newsData = [];

    if (sections && sections.length) {
        const sec = sections[0];
        if (!isLoggedIn && sec.privateTab) {
            tData[0] = {
                notExpandable: true,
                component: () => sectionPrivateTab(sec.sectionTitle),
            };
        } else {
            tData[0] = {
                id: sec.sectionTitle,
                title: sec.sectionTitle,
                children: () => section(sec.sectionContent, sec.subSections),
                expandTab: true,
            };
        }

        for (let i = 1, len = sections.length; i < len; i++) {
            const { privateTab, sectionTitle, sectionContent, subSections } = sections[i];
            if (!isLoggedIn && privateTab) {
                tData[i] = {
                    notExpandable: true,
                    component: () => sectionPrivateTab(sectionTitle),
                };
            } else {
                tData[i] = {
                    id: sectionTitle,
                    title: sectionTitle,
                    children: () => section(sectionContent, subSections),
                };
            }
        }
    }

    if (news && news.length) {
        newsData[0] = {
            id: "news" + 0,
            title: news[0].newsTitle,
            children: () => (
                <div
                    className="expanded-content"
                    dangerouslySetInnerHTML={{ __html: DOMPurify?.sanitize?.(news[0].newsContentHtml) }}
                />
            ),
            expandTab: true,
        };

        for (let i = 1, len = news.length; i < len; i++) {
            newsData[i] = {
                id: "news" + i,
                title: news[i].newsTitle,
                children: () => (
                    <div
                        className="expanded-content"
                        dangerouslySetInnerHTML={{ __html: DOMPurify?.sanitize?.(news[i].newsContentHtml) }}
                    />
                ),
            };
        }
    }

    return (
        <div className="flex column expanded-container">
            <div className="flex column">
                <h3 className="my-0 mt-12">{title}</h3>
                <div className="flex column expanded-items">
                    {sections && sections.length ? <MultipleExpandableTabs closeAll={false} tabsData={tData} /> : null}
                    {documents && documents.length ? (
                        !isLoggedIn ? (
                            sectionPrivateTab("Dokumente")
                        ) : (
                            <ExpandableTab title="Dokumente">
                                <div className={"expanded-content"}>
                                    <PropertyDocuments
                                        propertyDocumentsData={documents.map(({ list }) => {
                                            if (list) {
                                                return {
                                                    title: list.title,
                                                    path: list.path,
                                                    description: list.description,
                                                };
                                            } else {
                                                return {};
                                            }
                                        })}
                                    />
                                </div>
                            </ExpandableTab>
                        )
                    ) : (
                        ""
                    )}
                    {newsData.length ? (
                        <ExpandableTab title="News" expandTab>
                            <div className="show">
                                <div className="flex column expanded-container sub-sections">
                                    <div className="flex column">
                                        <MultipleExpandableTabs closeAll={false} tabsData={newsData} />
                                    </div>
                                </div>
                            </div>
                        </ExpandableTab>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default ExpandedTabsBlock;
